import React from 'react';
import { Header, Segment } from 'semantic-ui-react';

const PermissionDenied = () => (
  <Segment basic>
    <Header as='h3' textAlign='center'>
      You are not allowed to access this resource
    </Header>
  </Segment>
);

export default PermissionDenied;



// WEBPACK FOOTER //
// ./src/component/PermissionDeniedPage/index.js